import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledEventInfoType = styled.p`
  line-height: 1;
  margin-bottom: ${tvar('space.x1')};
`;

export const StyledEventInfoColorSwatch = styled.span<{ $color?: string }>`
  display: inline-block;
  width: 1.4rem;
  height: 1.4rem;
  margin-right: ${tvar('space.x1')};
  background: ${({ $color, theme }) => $color || theme.colors.fill.inverted};
`;

export const StyledEventInfoHeading = styled.h3`
  margin-bottom: ${tvar('space.x1')};
`;

export const StyledEventInfoModuleList = styled.ul`
  padding-left: ${tvar('space.x2')};
  margin-bottom: ${tvar('space.x2')};

  li {
    font-weight: 400;
  }
`;

export const StyledEventInfoDate = styled.p`
  font-size: ${tvar('typographies.large.fontSize')};
  margin-bottom: ${tvar('space.x2')};
`;

export const StyledEventInfoMisc = styled.p`
  margin-bottom: ${tvar('space.x1')};
`;
export const StyledEventInfoLocation = styled.p`
  display: flex;
  margin-bottom: 0;
  margin-top: ${tvar('space.x2')};
  svg {
    position: relative;
    left: -0.3rem;
  }
`;
